

const useDefaultPermissions = (lang: string, role: string) => {
  const englishList = {
    admins: [
      'Add, edit, and delete administrators.',
      'Add, edit, and delete directors.',
      'Add, edit, and delete teachers.',
      'Add, edit, and delete students.',
      'Add, edit, and delete centers.',
      'Add, edit, and delete classrooms.',
      'Add, edit and delete calendar events.',
      'Move students from center or classroom.',
      'Move directors and teachers from center.',
      'Add, edit, and delete plans.',
      'Add, edit, and delete activities from catalog (only own activities).',
      'Add and delete collections (Catalog section).',
      'Assign directors to more than one center.',
      'Assign teachers to more than one center.',
      'Delete categories, subcategories, and resources (Resources section).',
      'Edit center configuration.',
      'Create and delete forums.',
    ],
    directors: [
      'Add, edit, and delete classrooms.',
      'Add, edit, and delete teachers.',
      'Add, edit, and delete students.',
      'Add, edit and delete calendar events.',
      'Move students from center or classroom.',
      'Give special permissions to teachers.',
      'Add, edit, and delete plans.',
      'Add and delete collections in the Catalog.',
      'Add, edit, and delete activities from catalog (only own activities).',
      'Add categories, subcategories, and resources in the Resources section.',
      'Delete categories, subcategories, and resources in the Resources section.',
      'Create and delete forums.',
    ],
    teachers: [
      'View classrooms.',
      'Add activities.',
      'Add collections and subcollections in the Catalog.',
      'Schedule activities to weekly plan.',
      'Add categories, subcategories, and resources.',
    ],
  };
  const spanishList = {
    admins: [
      'Agregar, editar y eliminar administradores.',
      'Agregar, editar y eliminar directores.',
      'Agregar, editar y eliminar profesores.',
      'Agregar, editar y eliminar alumnos.',
      'Agregar, editar y eliminar escuela.',
      'Agregar, editar y eliminar salones.',
      'Agregar, editar y eliminar eventos de calendario.',
      'Mover alumnos de escuela o de salón.',
      'Mover directores y maestros de escuela.',
      'Agregar, editar y eliminar planes.',
      'Agregar, editar y eliminar actividades del catálogo (sólo actividades propias).',
      'Agregar y eliminar colecciones (sección de Catálogo).',
      'Asignar directores a más de una escuela.',
      'Asignar maestros a más de una escuela.',
      'Eliminar categorías, subcategorías y recursos (sección de Recursos).',
      'Editar la configuración de la escuela.',
      'Crear y eliminar foros.',
    ],
    directors: [
      'Agregar, editar y eliminar salones.',
      'Agregar, editar y eliminar maestros.',
      'Agregar, editar y eliminar alumnos.',
      'Agregar, editar y eliminar eventos de calendario.',
      'Mover alumnos de escuela o de salón.',
      'Dar permisos especiales a los maestros.',
      'Agregar, editar y eliminar planes.',
      'Agregar y eliminar colecciones (sección de Catálogo).',
      'Agregar, eliminar y editar actividades del catálogo (sólo actividades propias).',
      'Agregar categorías, subcategorías y recursos (sección de Recursos).',
      'Eliminar categorías, subcategorías y recursos (sección de Recursos).',
      'Crear y eliminar foros.',
    ],
    teachers: [
      'Ver salones.',
      'Agregar actividades.',
      'Agregar colecciones (Catálogo).',
      'Programar actividades a plan semanal.',
      'Agregar categorías, subcategorías y recursos.',
    ],
  };
  const portugueseList = {
    admins: [
      'Adicionar, editar e excluir administradores.',
      'Adicionar, editar e excluir diretores.',
      'Adicionar, editar e excluir professores.',
      'Adicionar, editar e excluir alunos.',
      'Adicionar, editar e apagar escola.',
      'Adicionar, editar e apagar salas.',
      'Adicionar, editar e apagar eventos de calendário.',
      'Mudar alunos de escola ou sala.',
      'Mudar diretores e professores de escola.',
      'Adicionar, editar e apagar planos.',
      'Adicionar, editar e apagar atividades do catálogo (apenas suas próprias atividades).',
      'Adicionar e apagar coleções (na aba Catálogo).',
      'Atribuir diretores a mais de uma escola.',
      'Atribuir professores a mais de uma escola.',
      'Apagar categorias, subcategorias e recursos (na aba Recursos).',
      'Editar configuração da escola.',
      'Criar e apagar chats em grup.',
    ],
    directors: [
      'Adicionar, editar e apagar salas.',
      'Adicionar, editar e excluir professores.',
      'Adicionar, editar e excluir alunos.',
      'Adicionar, editar e apagar eventos de calendário.',
      'Mudar alunos de escola ou sala.',
      'Permissões especiais aos professores.',
      'Adicionar, editar e apagar planos.',
      'Adicionar e apagar coleções (na aba Catálogo).',
      'Adicionar, editar e apagar atividades do catálogo (apenas suas próprias atividades).',
      'Adicionar categorias, subcategorias e recursos (na aba Recursos).',
      'Apagar categorias, subcategorias e recursos (na aba Recursos).',
      'Criar e apagar chats em grup.',
    ],
    teachers: [
      'Ver salas.',
      'Adicionar atividades.',
      'Adicionar coleções/ subcoleções (Catálogo).',
      'Agendar atividades de acordo com o plano semanal.',
      'Adicionar categorias, subcategorias e recursos.',
    ],
  };

  if (lang === 'es') {
    if (role === 'Administrator' || role === 'Owner') {
      return spanishList.admins;
    } if (role === 'Director') {
      return spanishList.directors;
    }

    return spanishList.teachers;
  }

  if (lang === 'pt') {
    if (role === 'Administrator' || role === 'Owner') {
      return portugueseList.admins;
    }

    if (role === 'Director') {
      return portugueseList.directors;
    }

    return portugueseList.teachers;
  }

  if (role === 'Administrator' || role === 'Owner') {
    return englishList.admins;
  }

  if (role === 'Director') {
    return englishList.directors;
  }

  return englishList.teachers;
};

export default useDefaultPermissions;
